import * as React from "react";
import { createLucideIcon, type LucideProps } from "lucide-react";

const BitbucketIcon = createLucideIcon("Bitbucket", [
  [
    "path",
    {
      fill: "currentColor",
      stroke: "none",
      d: "M24.9352 10.6331L22.9629 22.6811C22.8343 23.41 22.3197 23.8387 21.5909 23.8387H4.86944C4.14064 23.8387 3.62614 23.41 3.49744 22.6811L0.0245436 1.2005C-0.104056 0.4716 0.281844 0 0.967844 0H25.4925C26.1785 0 26.5644 0.4716 26.4358 1.2005L25.4925 6.86C25.3639 7.6747 24.8923 8.0177 24.1205 8.0177H9.37144C9.15704 8.0177 9.02844 8.1463 9.07124 8.4035L10.2289 15.5209C10.2717 15.6924 10.4004 15.821 10.5719 15.821H15.8884C16.0599 15.821 16.1886 15.6924 16.2314 15.5209L17.0461 10.3758C17.1318 9.7327 17.5606 9.4754 18.1608 9.4754H23.949C24.8065 9.4754 25.0638 9.9042 24.9352 10.6331Z",
      key: "path-0",
    },
  ],
]) as any;

export const Bitbucket = React.forwardRef<SVGSVGElement, LucideProps>(
  ({ className = "lucide-logo", viewBox = "0 0 27 24", ...props }, ref) =>
    React.createElement(BitbucketIcon, {
      ref,
      className,
      viewBox,
      ...props,
    }),
) as any;

Bitbucket.displayName = "Bitbucket";
